import { useIsUserSuperAdmin } from '@/stores/useStore.js'
import { useCurrentSubscription } from './useCurrentSubscription.ts'
import { useDefaultOrganizationId } from './useDefaultOrganizationId.ts'
import { useQuery } from '@tanstack/react-query'
import { getActiveWorkspacesLimit } from '@/services/Firebase.ts'

export function useProvisionedVMsQuery() {
  const currentOrganizationId = useDefaultOrganizationId()
  const isSuperAdmin = useIsUserSuperAdmin()
  const currentSubscription = useCurrentSubscription()
  const query = useQuery({
    enabled: Boolean(currentOrganizationId),
    staleTime: 1000 * 60 * 60 * 24,
    queryKey: ['provisionedVMs', currentOrganizationId, isSuperAdmin, currentSubscription?.priceId],
    queryFn: async () => {
      if (isSuperAdmin) {
        return Number.POSITIVE_INFINITY
      }

      const result = await getActiveWorkspacesLimit({ organizationId: currentOrganizationId })
      return result.data
    },
  })

  return query
}
